/**
 * External dependencies
 */
import deepmerge from 'deepmerge'

export const createStyles = props => {
	const styles = []

	return deepmerge.all( styles )
}

export default createStyles